import { ColorName } from '@shinetools/sunshine';

import { isCreditCardPendingOrder } from 'common/creditCards/isCreditCardPendingOrder';

import { CreditCard } from '../../../../hooks/useCreditCards';
import locales from './locales';

export const getPaymentCardStatusBadgeColor = (
  creditCard: CreditCard,
): ColorName => {
  const { status } = creditCard;

  if (!isCreditCardPendingOrder(creditCard) && creditCard.pinTryExceeds) {
    return 'red';
  }

  switch (status) {
    case 'ACTIVE':
      return 'green';
    case 'LOST':
    case 'STOLEN':
    case 'LOCKED':
      return 'red';
    case 'INACTIVE':
    default:
      return 'yellow';
  }
};

export const getPaymentCardStatusBadgeLabel = (
  creditCard: CreditCard,
): string => {
  const { status } = creditCard;
  if (!isCreditCardPendingOrder(creditCard) && creditCard.pinTryExceeds) {
    return locales.LOCKED;
  }

  return locales[status];
};
